import Search from "@mui/icons-material/Search";
import { Box } from "@mui/system";
import { BreadcrumbItem, Breadcrumbs } from "@vds/breadcrumbs";
import { Button } from "@vds/buttons";
import { Input } from "antd";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  deleteCVApplicationEndPoint,
  fetchCVApplicationEndPoint,
} from "../../configuration";
import "../../styles/deviceStyle.css";

// import {  getCVAppData } from "../../global/utility/Utils";
// import AppTable from "../../global/components/Tables/AppTable";
import { useSelector } from "react-redux";
import axiosInstance from "../../global/axiosInterceptor";
import CVAppsTable from "../../global/components/Tables/CVAppsTable";
import { DeleteCVAppModal } from "./CVAppsModal";
import { CVAPPS_TEST_IDS } from "./cvAppsConstants";

const CVApps = () => {
  const { activeSession } = useSelector(
    (state) => state.sessionReducer.activeSession
  );
  let navigate = useNavigate();
  const { state } = useLocation();

  const [apiLoading, setApiLoading] = useState({
    cvAppTable: false,
  });
  const [cvAppList, setCVAppList] = useState([]);
  const [fetchCVApp, setFetchCVApp] = useState(false);
  const [searchDevice, setSearchDevice] = useState("");
  const [refreshCVApp, setRefreshCVApp] = useState(false);
  const [tableLoading, setTableLoading] = useState(false);
  const [selectedCVApp, setSelectedCVApp] = useState();
  const [showDeleteCVApp, setShowDeleteCVApp] = useState(false);
  const [deleteCVAppConfirmed, setDeleteCVAppConfirmed] = useState(false);
  const [resourceId, setResourceId] = useState();

  const fetchCVApps = async () => {
    try {
      setApiLoading((prev) => ({ ...prev, cvAppTable: true }));
      setCVAppList([]);
      const cvAppRsp = await axiosInstance.post(fetchCVApplicationEndPoint(), {
        accountname: activeSession.accountId,
      });

      const data = cvAppRsp.data;
      const status = cvAppRsp.status;

      const rowdata = data.filter((item) => item.status !== "deprecated");

      setFetchCVApp(rowdata);
      setRefreshCVApp(true);
    } catch (e) {
      console.log(e);
      setApiLoading((prev) => ({ ...prev, cvAppTable: false }));
    }
  };

  useEffect(() => {
    if (!refreshCVApp) {
      fetchCVApps();
    }
  }, [refreshCVApp]);

  const onConfirm = async (record) => {
    try {
      setDeleteCVAppConfirmed(true);
      setShowDeleteCVApp(false);
      console.log("Deleteing the CVApp", resourceId);
      const response = await axiosInstance.delete(
        deleteCVApplicationEndPoint(),
        {
          data: {
            accountname: activeSession.accountId,
            resourceidentifier: { id: resourceId },
          },
        }
      );

      // console.log("onconfirm",selectedCVApp.id);
      setTimeout(() => {
        fetchCVApps();
      }, 2000);
    } catch (e) {
      console.log(e);
    }
  };
  const onExit = () => {
    setDeleteCVAppConfirmed(false);
    setShowDeleteCVApp(false);
  };

  const CreateCVApps = () => {
    navigate("/CreateCVApps");
  };

  return (
    <>
      <div style={{ display: "flex" }}>
        <Breadcrumbs surface="light">
          <BreadcrumbItem>Dashboard</BreadcrumbItem>
          <BreadcrumbItem>CVApps</BreadcrumbItem>
        </Breadcrumbs>
      </div>
      <h2
        className="sasp_vz-nhg-eds-font"
        style={{ fontWeight: "700", fontSize: "32px" }}
      >
        CVApps
      </h2>

      <DeleteCVAppModal
        showDeleteCVApp={showDeleteCVApp}
        setShowDeleteCVApp={setShowDeleteCVApp}
        message="Do you want to delete CVApp"
        title="Delete CVApp"
        onConfirm={onConfirm}
        onExit={onExit}
      />

      <Box sx={{ p: 2, width: "100%" }}>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <Input
            style={{
              width: "25%",
              minWidth: "300px",
              borderColor: "black",
              borderLeftWidth: 0,
              borderTopWidth: 0,
              borderRightWidth: 0,
              borderRadius: 0,
            }}
            prefix={<Search />}
            placeholder="Search"
            onChange={(event) => {
              setSearchDevice(event.target.value);
            }}
            data-testid={CVAPPS_TEST_IDS.CVAPPS_SEARCH_INPUT}
          />
        </div>
      </Box>

      <div
        style={{ width: "100%", paddingBottom: "13px" }}
        className="d-flex justify-content-end"
      >
        <Button size="small" use="primary" onClick={CreateCVApps}>
          Create CVApps
        </Button>
      </div>

      <CVAppsTable
        appList={fetchCVApp}
        pagination={{
          position: ["bottomRight"],
          pageSize: 10,
        }}
        tableTitle="CV Apps"
        style={{ minHeight: "33vh" }}
        buttonLabel="Subscribe"
        pageName="cvApps"
        hiddenColumns={["created on"]}
        searchInputText={searchDevice}
        handleDelete={onConfirm}
        handleRefresh={fetchCVApps}
        setShowDeleteCVApp={setShowDeleteCVApp}
        setResourceId={setResourceId}
        setSelectedCVApp={setSelectedCVApp}
        selectedCVApp={selectedCVApp}
        setRefreshCVApp={setRefreshCVApp}
      />
    </>
  );
};

export default CVApps;
